import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Switch } from '../ui/switch';

export const SettingsField = ({ section, field, value, onChange }) => {
  const [key, label, type, options = {}] = field;
  const id = `settings-${section}-${key.replace(/[A-Z]/g, c => '-' + c.toLowerCase()).replace(/_/g, '-')}`;
  const { options: choices, ...inputProps } = options;
  if (type === 'switch') return <div className="owner-switch-row"><Label htmlFor={id}>{label}</Label><Switch id={id} data-testid={id} checked={!!value} onCheckedChange={onChange} /></div>;
  return <div className="space-y-2"><Label htmlFor={id}>{label}</Label>
    {type === 'textarea' ? <Textarea id={id} data-testid={id} value={value ?? ''} onChange={e => onChange(e.target.value)} rows={4} {...inputProps} />
      : type === 'select' ? <select id={id} data-testid={id} className="owner-select" value={value} onChange={e => onChange(e.target.value)}>{choices.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
        : <Input id={id} data-testid={id} type={type} value={value ?? ''} onChange={e => onChange(type === 'number' && e.target.value !== '' ? Number(e.target.value) : e.target.value)} {...inputProps} />}
  </div>;
};